(function () {

    angular
        .module('ngmvac')
        .controller('AutoDetailsController', AutoDetailsController);

    AutoDetailsController.$inject = ['AutoFactory', '$window'];

    function AutoDetailsController(AutoFactory, $window) {
        
        var vm          = this;
        vm.social       = ['Google', 'Facebook', 'Youtube', 'Twitter', 'Yahoo', 'Bing', 'Recomendacion', 'Otros'];
        vm.form         = {};
        vm.datos_vuelo  = false;

        var init = function(){
            AutoFactory.getAuto().then(function (response) {
                
                vm.cotizador = response.data.cotizador;
                vm.auto      = response.data.auto;
                vm.totals    = response.data.totals;

			    $('#loaderrese').hide();
                console.log(vm.auto, "auto");
                console.log(vm.cotizador, "cotizador");
                console.log(vm.totals, "totals");
            });
        }
        init();

        vm.save = function(){

            var params = {
                params : {
                    cliente: {
                        nombre              : vm.form.nombre,
                        apellidos           : vm.form.apellidos,
                        email               : vm.form.email,
                        telefono            : vm.form.telefono,
                        telefono_celular    : vm.form.telefono_celular,
                        via                 : vm.form.about_us
                    },
                    cotizador : vm.cotizador,
                    auto      : vm.auto
                }
            }

            if(vm.datos_vuelo){
                params.params.cliente.datos_vuelo = vm.vuelo;
            }
            
            AutoFactory.save( params ).then(function( response ){
                if (response.status == 200) {
                    var path = response.data.path;
                    $window.location.href = '/' + path;
                }
                console.log( response );
            });
        }        
    }

})();